<script setup lang="ts">
/**
 * TODO
 * - [ ] check for updates via update / move / file actions
 * - [ ] remove multi-item history, or have some max, e.g. 10 files/folders
 * - [ ] do not request more items than what can be viewed in the panel
 */

const { state: panelState } = usePanel()
const { targetFile, onTargetUpdated, fileHistoryEvents } = useFileActivity()

onMounted(() => {
  panelState.value.loading = true
})

onUnmounted(() => {
  panelState.value.loading = false
})

watchImmediate(targetFile, onTargetUpdated)
</script>

<template>
  <div class="activity">
    <div class="viewing-activity">
      <div class="viewing-activity-header">
        <div class="viewing-activity-menu">
          <div class="left">
            Viewing activity
          </div>
          <panel-activity-filter-menu class="right" />
        </div>
      </div>
      <div v-if="targetFile" class="viewing-activity-files">
        <file-item
          :key="targetFile.fileId"
          class="file-item"
          :file="targetFile"
        />
      </div>
    </div>
    <div class="separator" />
    <interface-scrollbar v-if="targetFile" vertical>
      <template v-for="event, idx in fileHistoryEvents" :key="event.timestamp">
        <panel-activity-history-event
          :file="targetFile"
          :event
          :current="idx === 0"
        />
      </template>
    </interface-scrollbar>
    <div v-else class="unsupported">
      Please select a single file to view its activity
      <div />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.activity
  @apply h-full flex flex-col

.viewing-activity
  @apply  flex-none space-y-[10px] p-[#{$panel-p-default}]

.viewing-activity-header
  @apply

.viewing-activity-menu
  @apply flex items-center justify-between
  .left
    @apply t-panel-sm text-[#{$global-t-tertiary}]

.viewing-activity-files
  @apply space-y-1

.separator
  @apply h-0 w-full border-b-0.75 border-b-[#{$menu-b-separator}]

.file-item
  @apply gap-1.5

.unsupported
  @apply p-[#{$panel-p-default}] text-[#{$global-t-quaternary}]
</style>
